// tslint:disable: max-line-length

import React from "react";
import Helmet from "react-helmet";
import { AboutEnquireCta, AboutExperts, AboutHero, AboutMenu, AboutOurStory, AboutOverviewHowItWorks, AboutTeam, AboutVideo } from "..";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./overview.scss";

export const AboutOverview = () => {
  return (
    <>
      <Helmet
        title="About us"
        link={[
          {
            rel: "canonical",
            href: `${globalConfig.wwwBaseUrl}${WebRoutes.aboutHome()}`,
          },
        ]}
      />
      <div className="about-overview">
        <div className="about-overview__menu">
          <div className="width-wrapper">
            <div className="columns">
              <div className="column is-4-tablet is-3-desktop">
                <AboutMenu overview={true} />
              </div>
            </div>
          </div>
        </div>

        <div id="overview" data-scroll-id="about-section-overview">
          <section id="header">
            <AboutHero />
          </section>
          <section>
            <AboutVideo />
          </section>
        </div>
        <section id="our-story" data-scroll-id="about-section-story">
          <AboutOurStory />
        </section>
        <section id="how-it-works" data-scroll-id="about-section-works">
          <AboutOverviewHowItWorks />
        </section>
        <section id="meet-the-team" data-scroll-id="about-section-team">
          <AboutTeam
            title="Meet our friendly team"
            content="Since our founding in 2012, TravelLocal has gone from strength to strength. What started as a conversation between Tom and Huw has grown into an exciting team of talented individuals all focusing on making it possible for travellers to have the best holidays by being put in touch with local experts."
            linkText="Meet the team"
            linkUrl={WebRoutes.aboutMeetTheTeam()}
          />
        </section>
        <section id="our-local-experts" data-scroll-id="about-section-experts" className="about-section about-section--experts about-bottom-boundary">
          <AboutExperts />
        </section>
        <section id="find-your-destination">
          <AboutEnquireCta />
        </section>
      </div>
    </>
  );
};
